import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  IAppErrorFactory,
  IAnswersService,
  IUserAnswerFactory,
  IUseCaseOutputFactory,
  IUserAnswer,
  ICreateMyReplyUseCase,
  CreateMyReplyUseCaseInput,
  CreateMyReplyUseCaseOutput,
} from '../../types'

@injectable()
export default class CreateMyReplyInteractor implements ICreateMyReplyUseCase {
  @inject(symbols.IAnswersService) private answersService: IAnswersService

  @inject(symbols.IUserAnswerFactory) private userAnswerFactory: IUserAnswerFactory

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  @inject(symbols.IUseCaseOutputFactory) private outputFactory: IUseCaseOutputFactory<{
    reply: null | IUserAnswer
  }>

  async handle(input: CreateMyReplyUseCaseInput): Promise<CreateMyReplyUseCaseOutput> {
    const output = this.outputFactory.create({
      defaultValue: {
        reply: null,
      },
    })
    try {
      const base = await this.answersService.createMyReply(input)
      output.data.reply = this.userAnswerFactory.create({ base })
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
        messageForUI: 'Failed to add your reply.',
      })
    }

    return output
  }
}
